import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, workspace, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-start px-8 text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  // Force password change if flagged (except on the change-password page itself)
  if (user.must_change_password && location.pathname !== "/app/change-password") {
    return <Navigate to="/app/change-password" replace />;
  }
  // Workspace pending / rejected approval — pin them to the pending screen
  const wsStatus = workspace?.approval_status || "approved";
  if (
    wsStatus !== "approved" &&
    user.role !== "platform_admin" &&
    location.pathname !== "/app/pending-approval" &&
    location.pathname !== "/app/change-password"
  ) {
    return <Navigate to="/app/pending-approval" replace />;
  }
  // Platform admin lives under /app/admin/* — unless they're impersonating a workspace
  if (
    user.role === "platform_admin" &&
    location.pathname === "/app/dashboard" &&
    !localStorage.getItem("co_impersonate_ws")
  ) {
    return <Navigate to="/app/admin/workspaces" replace />;
  }
  return children;
}
